<template>
  <div>
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-8">
        <v-tabs class="ml-6 tabsLeft" color="#215DA7">
          <v-tabs-slider color="#215DA7"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">報名資訊</span></v-tab>
        </v-tabs>
      </v-col>
      <v-col class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div v-if="datasets.payStatus!='3' && datasets.payStatus!='4'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item @click="$refs.DeleteConfirm.open(2,'','',true), deleteId = $route.query.deliverId">
                <v-list-item-title>
                  <span>刪除考生</span>
                </v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="getRegDetail()">
                <v-list-item-title>
                  <span>拋至題庫端</span>
                </v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </div>

        <!-- <v-btn class="btn" outlined style="width:140px" @click="$refs.DeleteConfirm.open(2,'','',true), deleteId = $route.query.deliverId">
          <v-icon class="pr-2" size="16">mdi-delete</v-icon>
          <span>刪除考生</span>
        </v-btn> -->
      </v-col>
    </v-row>

    <div id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考生資訊</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>羅馬拼音</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="請務必填寫正確護照姓名，若需修正需付費申請" v-model="datasets.englishName"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>身分證字號(ID)</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>出生年月日</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.birthday"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>性別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.gender">
                  <v-row>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">女</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">男</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不提供</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.email"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4"></v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.company"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.department"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">聯絡電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.tel"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.ctel"
                @keyup="[datasets.ctel= datasets.ctel.replace(/\D/g,'')]" :maxlength="10"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0" v-if="datasets.citizenShip=='1' || !datasets.citizenShip">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>郵遞區號</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.zipCode"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-row class="px-3" v-if="datasets.citizenShip=='1' || !datasets.citizenShip">
                  <v-text-field class="text_field mr-2" dense readonly background-color="#F4F8F9" outlined v-model="datasets.country"></v-text-field>
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.area"></v-text-field>
                </v-row>
                <v-row class="px-3">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.address"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>企業徵才用</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.recruitmentAgree">
                  <v-row class="mr-0 pa-0">
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">同意</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不同意</span>
                      </template>
                    </v-radio>
                    <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                      <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                    </div>
                    <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:96px">
                      <h4 class="px-2 pt-3" style="font-size:12pt">※ 已同意將個資提供中華企業資源規劃學會使用</h4>
                      <h4 class="px-2 pb-3" style="font-size:12pt">我願意被企業徵才查詢</h4>
                    </div>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>報考身份別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.examMemberType">
                  <v-row>
                    <v-radio v-if="datasets.examMemberType == 1" class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">一般</span>
                      </template>
                    </v-radio>
                    <v-radio v-if="datasets.examMemberType != 1" class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">一般</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="3" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">老師</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="4" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">身心障礙</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="5" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">低收入戶</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="6" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">其他</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>收據抬頭</div>
              </v-col>
              <v-col class="col-9 col-sm-7 col-md-5">
                <v-text-field class="text_field" dense outlined placeholder="請輸入收據抬頭" readonly background-color="#F4F8F9"
                  v-model="datasets.receiptTitle">
                </v-text-field>
              </v-col>
              <v-col class="col-6 col-sm-3 col-md-5 pt-1">
                <v-checkbox class="ma-0 pa-0" readonly v-model="datasets.sameName">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">與中文姓名同</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2 py-1">
          <v-col class="px-0 col-2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
          </v-col>
          <v-col v-if="datasets.memberType=='erpMember'" class="col-10 col-md-8 py-0 pt-2 pl-5">
            <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.jobtitle">
              <v-row>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">高中生(含五專)</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="2" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">大學生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="3" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">碩士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="4" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">博士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="5" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">教師</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="6" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">社會人士</span>
                  </template>
                </v-radio>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col v-if="datasets.memberType!='erpMember'" class="col-10 col-md-4">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.jobtitle"></v-text-field>
          </v-col>
        </v-row>
      </div>
      
      <div class="mt-8"> 
        <v-row class="ma-0 pa-0" justify="center">
          <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#FFFFFF; border-radius:8px; border: 1px solid #81c0e2" @click="redirectPath('/project')">
            <span style="color:#81c0e2">返回</span>
          </v-btn>
        </v-row>
      </div>
  </div>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <DeleteConfirm ref="DeleteConfirm" :onSave="deleteExamReg"/>
  </div>
</template>

<script>
import ShowMsg from '@/dialogs/ShowMsg'
import DeleteConfirm from '@/dialogs/DeleteConfirm'

export default {
  name: 'ProjectMemberInfo',
  components: {ShowMsg,DeleteConfirm},
  mounted(){
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.getDataset()
  },
  data:() => ({
    datasets: [],
    viewStyle:{},
    mouseInfor:0,
    collegeCategoryList: [],
    hideIdCard:'',
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.$route.query.tab,
      }})
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamReg/' + JSON.parse(this.$Global.decrypt(this.$route.query.deliverId)),
        params: {
          source: 'cerpsTeacher',
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pmf-7956')
      }).finally(()=>{
        // this.hideIdCard = this.formatIDcard(this.datasets.idCard)
        // this.hideIdCard = this.datasets.idCard.toString().replace(/^(.{3})(.{4})(.{3})$/ , '$1****$3')
      })
    },
    // formatIDcard (value) {
    //   if (!value) return '';
    //   let str = value;
    //   str = str.toString().replace(/^(.{3})(.{4})(.{3})$/ , '$1****$3')
    //   return str;
    // },
    deleteExamReg(){
      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExamRegStatusUpdate/' + JSON.parse(this.$Global.decrypt(this.$route.query.deliverId)),
        params: {},
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$refs.ShowMsg.open(0,'已刪除資料','您已刪除資料 !',true)
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deleteExamRegStatusUpdateInfo', //type
          self.datasets.examNo, //examNo
          JSON.parse(self.$Global.decrypt(self.$route.query.deliverId)), //logContent
          '', //note1
        )
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Pmf-7957')
      }).finally(()=>{
      })
    },
    getRegDetail(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamSyncRegToRegDetail/' + JSON.parse(this.$Global.decrypt(this.$route.query.deliverId)),
      }
      this.$http(request).then(function(response) {
        console.log(response.data)
        // self.datasets = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pmf-7956')
      }).finally(()=>{
      })
    },
    onShowMsg(){
      this.redirectPath('/project')
    },
  }
}
</script>